function noop() {}
export { noop };